import auth from "@/middleware/auth";
import admin from "@/middleware/admin";

export const statusRoutes = [
  {
    path: "/directories/status",
    name: "StatusList",
    meta: { middleware: [auth, admin] },
    component: () =>
      import(/* webpackChunkName: "status" */ "./components/List"),
  },
];
